import React from "react";

type PropsType = {
  className?: string;
  size?: number;
};

const BookingNotification: React.FC<PropsType> = ({ size = 50, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
    >
      <rect
        x="16.6699"
        y="31.8674"
        width="10.7727"
        height="16.1591"
        rx="5.38636"
        fill="white"
        stroke="#003125"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <mask
        id="path-2-outside-1_272_13074"
        maskUnits="userSpaceOnUse"
        x="2"
        y="9.11755"
        width="41"
        height="33"
        fill="black"
      >
        <rect fill="white" x="2" y="9.11755" width="41" height="33" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.366 22.4004C11.3654 22.4085 11.3586 22.4149 11.3505 22.4149C11.3428 22.4149 11.3363 22.4205 11.3351 22.4281L9.64895 33.6693C9.52657 34.4851 8.82572 35.0887 8.00072 35.0887H6.66667C5.74619 35.0887 5 35.8349 5 36.7554V37.3826C5 38.3031 5.74619 39.0493 6.66667 39.0493H38.1863C39.1067 39.0493 39.8529 38.3031 39.8529 37.3826V36.7554C39.8529 35.8349 39.1067 35.0887 38.1863 35.0887H36.5718C35.7313 35.0887 35.0222 34.4628 34.918 33.6288L33.5179 22.4283C33.517 22.4206 33.5104 22.4149 33.5027 22.4149C33.4946 22.4149 33.4879 22.4085 33.4873 22.4005C33.0742 16.6524 28.28 12.1175 22.4266 12.1175C16.5733 12.1175 11.7792 16.6524 11.366 22.4004Z"
        />
      </mask>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.366 22.4004C11.3654 22.4085 11.3586 22.4149 11.3505 22.4149C11.3428 22.4149 11.3363 22.4205 11.3351 22.4281L9.64895 33.6693C9.52657 34.4851 8.82572 35.0887 8.00072 35.0887H6.66667C5.74619 35.0887 5 35.8349 5 36.7554V37.3826C5 38.3031 5.74619 39.0493 6.66667 39.0493H38.1863C39.1067 39.0493 39.8529 38.3031 39.8529 37.3826V36.7554C39.8529 35.8349 39.1067 35.0887 38.1863 35.0887H36.5718C35.7313 35.0887 35.0222 34.4628 34.918 33.6288L33.5179 22.4283C33.517 22.4206 33.5104 22.4149 33.5027 22.4149C33.4946 22.4149 33.4879 22.4085 33.4873 22.4005C33.0742 16.6524 28.28 12.1175 22.4266 12.1175C16.5733 12.1175 11.7792 16.6524 11.366 22.4004Z"
        fill="#FFD440"
      />
      <path
        d="M33.5179 22.4283L36.4948 22.0562L33.5179 22.4283ZM33.4873 22.4005L30.4951 22.6156L33.4873 22.4005ZM34.918 33.6288L31.9412 34.0009L34.918 33.6288ZM11.3351 22.4281L8.36832 21.9831L11.3351 22.4281ZM9.64895 33.6693L12.6158 34.1143L14.3019 22.8731L11.3351 22.4281L8.36832 21.9831L6.68214 33.2243L9.64895 33.6693ZM8.00072 35.0887V32.0887H6.66667V35.0887V38.0887H8.00072V35.0887ZM6.66667 35.0887V32.0887C4.08934 32.0887 2 34.178 2 36.7554H5H8C8 37.4918 7.40304 38.0887 6.66667 38.0887V35.0887ZM5 36.7554H2V37.3826H5H8V36.7554H5ZM5 37.3826H2C2 39.9599 4.08934 42.0493 6.66667 42.0493V39.0493V36.0493C7.40305 36.0493 8 36.6462 8 37.3826H5ZM6.66667 39.0493V42.0493H38.1863V39.0493V36.0493H6.66667V39.0493ZM38.1863 39.0493V42.0493C40.7636 42.0493 42.8529 39.9599 42.8529 37.3826H39.8529H36.8529C36.8529 36.6462 37.4499 36.0493 38.1863 36.0493V39.0493ZM39.8529 37.3826H42.8529V36.7554H39.8529H36.8529V37.3826H39.8529ZM39.8529 36.7554H42.8529C42.8529 34.178 40.7636 32.0887 38.1863 32.0887V35.0887V38.0887C37.4499 38.0887 36.8529 37.4918 36.8529 36.7554H39.8529ZM38.1863 35.0887V32.0887H36.5718V35.0887V38.0887H38.1863V35.0887ZM33.5179 22.4283L30.5411 22.8004L31.9412 34.0009L34.918 33.6288L37.8948 33.2567L36.4948 22.0562L33.5179 22.4283ZM33.4873 22.4005L36.4796 22.1854C35.9545 14.8794 29.8648 9.11751 22.4266 9.11751V12.1175V15.1175C26.6952 15.1175 30.1939 18.4255 30.4951 22.6156L33.4873 22.4005ZM22.4266 12.1175V9.11751C14.9886 9.11751 8.89893 14.8793 8.37369 22.1852L11.366 22.4004L14.3582 22.6155C14.6595 18.4255 18.1581 15.1175 22.4266 15.1175V12.1175ZM11.3505 22.4149V25.4149C12.9508 25.4149 14.2462 24.1741 14.3582 22.6155L11.366 22.4004L8.37369 22.1852C8.48458 20.6428 9.76645 19.4149 11.3505 19.4149V22.4149ZM33.5179 22.4283L36.4948 22.0562C36.3062 20.5472 35.0234 19.4149 33.5027 19.4149V22.4149V25.4149C31.9975 25.4149 30.7278 24.294 30.5411 22.8004L33.5179 22.4283ZM33.5027 22.4149V19.4149C35.0869 19.4149 36.3688 20.6431 36.4796 22.1854L33.4873 22.4005L30.4951 22.6156C30.6071 24.174 31.9023 25.4149 33.5027 25.4149V22.4149ZM9.64895 33.6693L6.68214 33.2243C6.78004 32.5716 7.34073 32.0887 8.00072 32.0887V35.0887V38.0887C10.3107 38.0887 12.2731 36.3987 12.6158 34.1143L9.64895 33.6693ZM36.5718 35.0887V32.0887C37.2442 32.0887 37.8114 32.5894 37.8948 33.2567L34.918 33.6288L31.9412 34.0009C32.2331 36.3362 34.2183 38.0887 36.5718 38.0887V35.0887ZM11.3505 22.4149V19.4149C9.85786 19.4149 8.58975 20.5068 8.36832 21.9831L11.3351 22.4281L14.3019 22.8731C14.0828 24.3341 12.8277 25.4149 11.3505 25.4149V22.4149Z"
        fill="#003125"
        mask="url(#path-2-outside-1_272_13074)"
      />
      <circle cx="22.5063" cy="8.97542" r="3.14205" fill="#003125" />
      <path
        d="M14.874 34.5605H30.5843"
        stroke="#003125"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.333 10L43.333 5"
        stroke="#003125"
        stroke-width="3.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M40 14.1666H45"
        stroke="#003125"
        stroke-width="3.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M34.167 2.91663V7.91663"
        stroke="#003125"
        stroke-width="3.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BookingNotification;
